import React, { Component } from 'react'
import PropTypes from 'prop-types'
import GoogleMapReact from 'google-map-react'
import { fitBounds } from 'google-map-react/utils'

import $ from 'jquery'
import { TweenMax, Power0, Power2 } from 'gsap'
import TimelineMax from 'gsap/TimelineMax'

import MapPin from 'containers/MapPin'

import './index.scss'
import Styles from './styles.json'

class LocationMap extends Component {
  constructor (props) {
    super(props)

    this.state = {
      maps: null,
      center: { lat: 0, lng: 0 },
      zoom: 5,
    }

    this.bounds = null
    this.zoomCenterFitAll = null
  }

  createMapOptions (maps) {
    return {
      minZoomOverride: true,
      minZoom: 2,
      disableDefaultUI: true,
      styles: Styles.styles
    }
  }

  componentDidUpdate (prevProps, prevState) {
    if (prevState.maps === null && this.state.maps) {
      let b
      if (this.props.locations.length >= 2) {
        this.bounds = new this.state.maps.LatLngBounds()
        this.calculateNewBounds()
        const boundsForFit = {
          ne: {
            lat: this.bounds.getNorthEast().lat(),
            lng: this.bounds.getNorthEast().lng()
          },
          sw: {
            lat: this.bounds.getSouthWest().lat(),
            lng: this.bounds.getSouthWest().lng()
          }
        }
        b = fitBounds(boundsForFit, { width: $(this.mapWrapper).width() * 0.8, height: $(this.mapWrapper).width() * 0.8 })
      } else {
        b = {
          center: this.getLatLngLiteralFromLocation(this.props.locations[0]),
          zoom: 4
        }
      }
      this.zoomCenterFitAll = { center: b.center, zoom: b.zoom }
      this.setState(this.zoomCenterFitAll) // eslint-disable-line
      TweenMax.fromTo(this.mapWrapper, 0.6, { x: '-100%' }, { x: 1, ease: Power0.easeNone })

      const timeline = new TimelineMax()
      timeline
        .fromTo(this.mapWrapper, 0.8, { x: '-100%' }, { x: '0%', ease: Power2.easeInOut })
        .fromTo($(this.mapWrapper).children('div'), 0.8, { x: '60%', opacity: 0 }, { x: '0%', opacity: 1, ease: Power2.easeInOut }, 0)
    }

    if (prevProps.selectedLocation !== this.props.selectedLocation) {
      // This runs if we click on the close button in the pin popover
      if (this.props.selectedLocation === false) {
        this.setState(this.zoomCenterFitAll) // eslint-disable-line
        return
      }

      const selectedLocationObject = this.props.locations.find(location => location.id === this.props.selectedLocation)
      const locationLatLng = {
        lat: parseFloat(selectedLocationObject.acf.map_location.lat),
        lng: parseFloat(selectedLocationObject.acf.map_location.lng)
      }

      this.setState({ // eslint-disable-line
        center: locationLatLng,
        zoom: 14
      })
    }

    if (prevProps.siteMenuVisible !== this.props.siteMenuVisible && this.props.siteMenuVisible === true) {
      const timeline2 = new TimelineMax()
      timeline2
        .to(this.mapWrapper, 0.8, { x: '-100%', ease: Power2.easeInOut })
        .to($(this.mapWrapper).children('div'), 0.8, { x: '60%', opacity: 0, ease: Power2.easeInOut }, 0)
    }

    if (prevProps.siteMenuVisible !== this.props.siteMenuVisible && this.props.siteMenuVisible === false) {
      const timeline3 = new TimelineMax()
      timeline3
        .fromTo(this.mapWrapper, 0.8, { x: '-100%' }, { x: '0%', ease: Power2.easeInOut })
        .fromTo($(this.mapWrapper).children('div'), 0.8, { x: '60%', opacity: 0 }, { x: '0%', opacity: 1, ease: Power2.easeInOut }, 0)
    }
  }

  componentWillLeave (callback) {
    const timeline = new TimelineMax({ onComplete: callback })
    timeline
      .to(this.mapWrapper, 0.8, { x: '-100%', ease: Power2.easeInOut })
      .to($(this.mapWrapper).children('div'), 0.8, { x: '60%', opacity: 0, ease: Power2.easeInOut }, 0)
  }

  renderPins () {
    return this.props.locations.map(location => {
      let latLng = this.getLatLngLiteralFromLocation(location)
      return (
        <MapPin
          key={`mapPin${location.id}`}
          isSelected={this.props.selectedLocation === location.id}
          location={location}
          lat={latLng.lat}
          lng={latLng.lng} />
      )
    })
  }

  // getCenterZoomFromBounds () {
  //    fitBounds(boundsForFit, { width: $(this.mapWrapper).width() * 0.8, height: $(this.mapWrapper).width() * 0.8 })
  // }

  calculateNewBounds () {
    this.props.locations.forEach(location => {
      this.bounds.extend(this.getLatLngLiteralFromLocation(location))
    }, this)
  }

  getLatLngLiteralFromLocation (location) {
    return { lat: parseFloat(location.acf.map_location.lat), lng: parseFloat(location.acf.map_location.lng) }
  }

  render () {
    return (
      <div className='location-map' ref={el => { this.mapWrapper = el }}>
        <GoogleMapReact
          onGoogleApiLoaded={({ map, maps }) => { this.setState({ maps }) }}
          yesIWantToUseGoogleMapApiInternals
          bootstrapURLKeys={{ key: 'AIzaSyDYhKpFo73m2N4Oo_DFW2EbINH8lTElf5A' }}
          options={this.createMapOptions}
          center={this.state.center}
          zoom={this.state.zoom}>
          { this.renderPins() }
        </GoogleMapReact>
      </div>
    )
  }
}

LocationMap.propTypes = {
  locations: PropTypes.array,
  selectedLocation: PropTypes.number
}

export default LocationMap



// WEBPACK FOOTER //
// ./src/components/LocationMap/index.js